import React from 'react';
import styles from './Slider.module.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export const Slider = ({ sliderType, children, height, onReachEnd}) => {
	return (
		<div style={{ overflow: 'visible' }}>
			<Swiper
				modules={sliderType === 'main' ? [Pagination, Autoplay] : []}
				slidesPerView={'auto'}
				spaceBetween={13}
				grabCursor={true}
				freeMode={true}
				pagination={
					sliderType === 'main'
						? { clickable: true }
						: false
				}
				autoplay={
					sliderType === 'main'
						? {
							delay: 5000, // каждые 5 секунд
							disableOnInteraction: false,
						}
						: false
				}
				onReachEnd={onReachEnd}
				className={styles.slider}
				style={{
					paddingLeft: '16px',
					paddingRight: '16px',
					height: '100%',
				}}
			>
				{React.Children.map(children, (child, index) => (
					<SwiperSlide
						className={
							sliderType === 'min'
								? height
									? styles.slide_w
									: styles.slide
								: undefined
						}
						key={index}
					>
						{child}
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};
